export default {
    accesos: [
        { route: 'dashboard', modulo: '' },
        { route: '', modulo: 'DashboardVentas' },
        { route: '', modulo: 'DashboardRentabilidadNeta' },
        { route: '', modulo: 'DashboardHistorico' },
        { route: '', modulo: 'DashboardCuentas' },
        { route: '', modulo: 'DashboardCuentasRentabilidadBruta' },
        { route: '', modulo: 'DashboardAdministracion' },
        { route: '', modulo: 'DashboardProduccion' },

        { route: 'ventas', modulo: '' },
        { route: 'ventas/presupuestosinternos', modulo: '' },
        { route: 'ventas/presupuestosinternos/:id', modulo: '' },
        { route: 'ventas/presupuestosinternos/:id/ABM', modulo: '' },
        { route: 'ventas/presupuestosinternos/:id/usuarios', modulo: '' },
        { route: 'ventas/presupuestosinternos/:id/produccion', modulo: '' },
        { route: 'ventas/presupuestosinternos/ordenestrabajo/:id/produccion', modulo: '' },
        { route: '', modulo: 'PresupuestosInternosCerrar' },
        { route: 'ventas/facturas-proforma', modulo: '' },
        { route: 'ventas/facturas-proforma/ABM', modulo: '' },
        { route: 'ventas/facturas-proforma/:id', modulo: '' },
        { route: 'ventas/certificados-servicio', modulo: '' },
        { route: 'ventas/certificados-servicio/:id', modulo: '' },
        { route: 'ventas/certificados-servicio/presupuesto/:presupuestoId/add', modulo: '' },
        { route: 'ventas/certificados-servicio/:id/edit', modulo: '' },
        { route: 'ventas/facturas', modulo: '' },
        { route: 'ventas/facturas/:id', modulo: '' },
        { route: 'ventas/facturas/ABM', modulo: '' },
        { route: 'ventas/facturas/ABMC', modulo: '' },
        { route: 'ventas/facturas/ABME', modulo: '' },
        { route: 'ventas/facturas/ABMCE', modulo: '' },
        { route: 'ventas/facturas/credito-financiacion', modulo: '' },
        { route: 'ventas/facturas/:id/credito-debito', modulo: '' },
        { route: 'ventas/facturas/:id/credito-financiacion', modulo: '' },
        { route: 'ventas/facturas/:id/credito-fee', modulo: '' },
        { route: 'ventas/facturas/:id/negociacion', modulo: '' },
        { route: 'ventas/facturas-negociadas', modulo: '' },
        { route: 'ventas/facturas-negociadas/:id', modulo: '' },
        { route: '', modulo: 'VentasValidarAFIP' },
        { route: '', modulo: 'VentasActualizarCAE' },
        { route: '', modulo: 'VentasActualizarFechaImputacion' },
        { route: '', modulo: 'VentasNegociarComprobante' },

        { route: 'logistica', modulo: '' },
        { route: 'logistica/remitos', modulo: '' },
        { route: 'logistica/remitos/add', modulo: '' },
        { route: 'logistica/remitos/:id/duplicado', modulo: '' },
        { route: 'logistica/remitos/:id', modulo: '' },
        { route: 'logistica/destinos', modulo: '' },
        { route: 'logistica/destinos/:id', modulo: '' },
        { route: 'logistica/destinos/:id/ABM', modulo: '' },

        { route: 'clientes', modulo: '' },
        { route: 'clientes/clientes', modulo: '' },
        { route: 'clientes/clientes/:id', modulo: '' },
        { route: 'clientes/clientes/:id/ABM', modulo: '' },
        { route: 'clientes/clientes/contactos/:clienteId', modulo: '' },
        { route: 'clientes/clientes/contactos/:clienteId/:id', modulo: '' },
        { route: 'clientes/clientes/contactos/:clienteId/:id/ABM', modulo: '' },
        { route: 'clientes/clientes/contactosadministracion/:clienteId/:id', modulo: '' },
        { route: 'clientes/clientes/contactosadministracion/:clienteId/:id/ABM', modulo: '' },
        { route: 'clientes/cobros', modulo: '' },
        { route: 'clientes/cobros/:id', modulo: '' },
        { route: 'clientes/cobros/ABM', modulo: '' },
        { route: 'clientes/cuentacorriente', modulo: '' },
        { route: 'clientes/rebate', modulo: '' },
        { route: 'clientes/retenciones-clientes', modulo: '' },
        { route: 'clientes/retenciones-clientes/:id', modulo: '' },

        { route: 'compras', modulo: '' },
        { route: 'compras/compras', modulo: '' },
        { route: 'compras/compras/add', modulo: '' },
        { route: 'compras/compras/ordenes-proveedores/add', modulo: '' },
        { route: 'compras/compras/remitos/add', modulo: '' },
        { route: 'compras/compras/:id', modulo: '' },
        // { route: 'compras/compras/:id/ABM', modulo: '' },
        { route: 'compras/compras/:id/credito-debito', modulo: '' },
        { route: 'compras/compras/:id/credito', modulo: '' },
        { route: 'compras/compras/viaticos/:viaticoId/add', modulo: '' },

        { route: 'proveedores', modulo: '' },
        { route: 'proveedores/proveedores', modulo: '' },
        { route: 'proveedores/proveedores/add', modulo: '' },
        { route: 'proveedores/proveedores/:id/edit', modulo: '' },
        { route: 'proveedores/proveedores/:id', modulo: '' },
        { route: 'proveedores/ordenesproveedores', modulo: '' },
        { route: 'proveedores/ordenesproveedores/:id', modulo: '' },
        { route: 'proveedores/ordenesproveedores/:id/ABM', modulo: '' },
        { route: 'proveedores/ordenesproveedores/orden-interna', modulo: '' },
        { route: '', modulo: 'OrdenesProveedoresCancelarSaldo' },
        { route: 'proveedores/pagos', modulo: '' },
        { route: 'proveedores/pagos/:id', modulo: '' },
        { route: 'proveedores/pagos/ABM', modulo: '' },
        { route: 'proveedores/cuentacorriente', modulo: '' },
        { route: 'proveedores/evaluaciones-proveedores', modulo: '' },
        { route: 'proveedores/evaluaciones-proveedores/:id', modulo: '' },

        { route: 'rrhh', modulo: '' },
        { route: 'rrhh/personal', modulo: '' },
        { route: 'rrhh/personal/add', modulo: '' },
        { route: 'rrhh/personal/:id/edit', modulo: '' },
        { route: 'rrhh/personal/:id', modulo: '' },
        { route: 'rrhh/ingresos-egresos', modulo: '' },
        { route: 'rrhh/ingresos-egresos/:id', modulo: '' },
        { route: 'rrhh/ingresos-egresos/:id/ABM', modulo: '' },
        { route: 'rrhh/viaticos', modulo: '' },
        { route: 'rrhh/viaticos/add', modulo: '' },
        { route: 'rrhh/viaticos/:id', modulo: '' },
        { route: 'rrhh/viaticos/:id/edit', modulo: '' },
        { route: '', modulo: 'ViaticosAutorizacion' },
        { route: '', modulo: 'ViaticosComprobantes' },
        { route: '', modulo: 'ViaticosSeleccionPersonal' },
        { route: '', modulo: 'ViaticosPagos' },
        { route: 'rrhh/encuestas', modulo: '' },
        { route: 'rrhh/encuestas/:id', modulo: '' },
        { route: 'rrhh/encuestas/:id/completar', modulo: '' },

        { route: 'impuestos', modulo: '' },
        { route: 'impuestos/organismos', modulo: '' },
        { route: 'impuestos/organismos/:id', modulo: '' },
        { route: 'impuestos/organismos/:id/ABM', modulo: '' },
        { route: 'impuestos/organismos/impuestos/:impuestoOrganismoId', modulo: '' },
        { route: 'impuestos/organismos/impuestos/:impuestoOrganismoId/:id', modulo: '' },
        { route: 'impuestos/organismos/impuestos/:impuestoOrganismoId/:id/ABM', modulo: '' },
        { route: 'impuestos/declaraciones-juradas', modulo: '' },
        { route: 'impuestos/declaraciones-juradas/:id', modulo: '' },
        { route: 'impuestos/declaraciones-juradas/:id/ABM', modulo: '' },
        { route: 'impuestos/pagos', modulo: '' },
        { route: 'impuestos/pagos/:id', modulo: '' },
        { route: 'impuestos/pagos/ABM', modulo: '' },
        { route: 'impuestos/estado', modulo: '' },
        { route: 'impuestos/planes-pagos', modulo: '' },
        { route: 'impuestos/planes-pagos/:id/ABM', modulo: '' },
        { route: 'impuestos/planes-pagos/:id/pago', modulo: '' },
        { route: 'impuestos/planes-pagos/:id', modulo: '' },

        { route: 'tablas', modulo: '' },
        { route: 'tablas/bancos', modulo: '' },
        { route: 'tablas/bancos/:id', modulo: '' },
        { route: 'tablas/bancos/:id/ABM', modulo: '' },
        { route: 'tablas/cargos', modulo: '' },
        { route: 'tablas/cargos/:id', modulo: '' },
        { route: 'tablas/cargos/:id/ABM', modulo: '' },
        { route: 'tablas/formaspago', modulo: '' },
        { route: 'tablas/formaspago/:id', modulo: '' },
        { route: 'tablas/formaspago/:id/ABM', modulo: '' },
        { route: 'tablas/giros-empresas', modulo: '' },
        { route: 'tablas/giros-empresas/add', modulo: '' },
        { route: 'tablas/giros-empresas/:id/edit', modulo: '' },
        { route: 'tablas/paises', modulo: '' },
        { route: 'tablas/paises/:id', modulo: '' },
        { route: 'tablas/paises/:id/ABM', modulo: '' },
        { route: 'tablas/provincias', modulo: '' },
        { route: 'tablas/provincias/:id', modulo: '' },
        { route: 'tablas/provincias/:id/ABM', modulo: '' },
        { route: 'tablas/localidades', modulo: '' },
        { route: 'tablas/localidades/:id', modulo: '' },
        { route: 'tablas/localidades/:id/ABM', modulo: '' },
        { route: 'tablas/plan-cuentas', modulo: '' },
        { route: 'tablas/tarjetasmarcas', modulo: '' },
        { route: 'tablas/tarjetasmarcas/:id', modulo: '' },
        { route: 'tablas/tarjetasmarcas/:id/ABM', modulo: '' },
        { route: 'tablas/bancosmovimientostipos', modulo: '' },
        { route: 'tablas/bancosmovimientostipos/:id', modulo: '' },
        { route: 'tablas/bancosmovimientostipos/:id/ABM', modulo: '' },
        { route: 'tablas/retencionestipos', modulo: '' },
        { route: 'tablas/retencionestipos/:id', modulo: '' },
        { route: 'tablas/retencionestipos/:id/ABM', modulo: '' },
        { route: 'tablas/retencionesregimenes', modulo: '' },
        { route: 'tablas/retencionesregimenes/:id', modulo: '' },
        { route: 'tablas/retencionesregimenes/:id/ABM', modulo: '' },
        { route: 'tablas/etiquetas-proveedores', modulo: '' },
        { route: 'tablas/etiquetas-proveedores/add', modulo: '' },
        { route: 'tablas/etiquetas-proveedores/:id', modulo: '' },
        { route: 'tablas/etiquetas-proveedores/:id/ABM', modulo: '' },
        { route: 'tablas/rubros-intereses-bancarios', modulo: '' },
        { route: 'tablas/rubros-intereses-bancarios/add', modulo: '' },
        { route: 'tablas/rubros-intereses-bancarios/:id/edit', modulo: '' },
        { route: 'tablas/rubros-intereses-bancarios/:id', modulo: '' },
        { route: 'tablas/viaticos-rubros', modulo: '' },
        { route: 'tablas/viaticos-rubros/add', modulo: '' },
        { route: 'tablas/viaticos-rubros/:id/edit', modulo: '' },
        { route: 'tablas/viaticos-rubros/:id', modulo: '' },

        { route: 'administracion', modulo: '' },
        { route: 'administracion/bancos', modulo: '' },
        { route: 'administracion/bancos/bancoscuentas', modulo: '' },
        { route: 'administracion/bancos/bancoscuentas/:id', modulo: '' },
        { route: 'administracion/bancos/bancoscuentas/:id/ABM', modulo: '' },
        { route: 'administracion/bancos/bancoscuentas/:id/saldos', modulo: '' },
        { route: 'administracion/bancos/bancoschequeras', modulo: '' },
        { route: 'administracion/bancos/bancoschequeras/:id', modulo: '' },
        { route: 'administracion/bancos/bancoschequeras/:id/ABM', modulo: '' },
        { route: 'administracion/bancos/bancoschequeras/:id/cheques', modulo: '' },
        { route: 'administracion/bancos/bancosmovimientos', modulo: '' },
        { route: 'administracion/bancos/bancosmovimientos/:id', modulo: '' },
        { route: 'administracion/bancos/bancosmovimientos/:id/ABM', modulo: '' },
        { route: 'administracion/bancos/cheques-propios', modulo: '' },
        { route: 'administracion/bancos/cheques-propios/:id', modulo: '' },
        { route: 'administracion/bancos/cheques-terceros', modulo: '' },
        { route: 'administracion/bancos/cheques-terceros/add', modulo: '' },
        { route: 'administracion/bancos/cheques-terceros/:id/edit', modulo: '' },
        { route: 'administracion/bancos/cheques-terceros/:id', modulo: '' },
        { route: 'administracion/bancos/transferencias-premios', modulo: '' },
        { route: 'administracion/bancos/transferencias-premios/ABM', modulo: '' },
        { route: 'administracion/cajas', modulo: '' },
        { route: 'administracion/cajas/cajas', modulo: '' },
        { route: 'administracion/cajas/cajas/:id/ABM', modulo: '' },
        { route: 'administracion/cajas/cajasregistros', modulo: '' },
        { route: 'administracion/cajas/cajasregistros/:id/movimientos', modulo: '' },
        { route: 'administracion/tarjetas', modulo: '' },
        { route: 'administracion/tarjetas/tarjetas', modulo: '' },
        { route: 'administracion/tarjetas/tarjetas/:id', modulo: '' },
        { route: 'administracion/tarjetas/tarjetas/:id/ABM', modulo: '' },
        { route: 'administracion/tarjetas/tarjetas/:tarjetaId/tarjetas-vencimientos', modulo: '' },
        { route: 'administracion/tarjetas/tarjetas/:tarjetaId/tarjetas-vencimientos/add', modulo: '' },
        { route: 'administracion/tarjetas/tarjetas/:tarjetaId/tarjetas-vencimientos/:id', modulo: '' },
        { route: 'administracion/tarjetas/tarjetas/:tarjetaId/tarjetas-plasticos', modulo: '' },
        { route: 'administracion/tarjetas/tarjetas/:tarjetaId/tarjetas-plasticos/add', modulo: '' },
        { route: 'administracion/tarjetas/tarjetas/:tarjetaId/tarjetas-plasticos/:id', modulo: '' },
        { route: 'administracion/tarjetas/tarjetas/:tarjetaId/tarjetas-plasticos/:id/edit', modulo: '' },
        { route: 'administracion/tarjetas/tarjetas-resumenes', modulo: '' },
        { route: 'administracion/tarjetas/tarjetas-resumenes/:id', modulo: '' },
        { route: 'administracion/tarjetas/tarjetas-resumenes/:tarjetaResumenId/pagos', modulo: '' },
        { route: 'administracion/tarjetas/tarjetas-resumenes/:tarjetaResumenId/pagos/add', modulo: '' },
        { route: 'administracion/tarjetas/tarjetas-resumenes/:tarjetaResumenId/pagos/:id', modulo: '' },
        { route: 'administracion/tarjetas/tarjetas-no-resumen', modulo: '' },
        { route: 'administracion/tarjetas/tarjetas-no-resumen/:tarjetaId', modulo: '' },
        { route: 'administracion/tarjetas/tarjetas-cupones', modulo: '' },
        { route: 'administracion/tarjetas/tarjetas-cupones/:id', modulo: '' },
        { route: 'administracion/tarjetas/tarjetas-cupones/:id/ABM', modulo: '' },
        { route: 'administracion/flujo-fondos', modulo: '' },
        { route: 'administracion/flujo-fondos/flujo', modulo: '' },
        { route: 'administracion/flujo-fondos/presupuestos', modulo: '' },
        { route: 'administracion/flujo-fondos/presupuestos/add', modulo: '' },
        { route: 'administracion/parametros', modulo: '' },
        { route: 'administracion/parametros/fe', modulo: '' },
        { route: 'administracion/parametros/inflacion', modulo: '' },
        { route: 'administracion/parametros/inflacion/:id/ABM', modulo: '' },
        { route: 'administracion/presupuestos-gastos', modulo: '' },
        { route: 'administracion/presupuestos-gastos/add', modulo: '' },
        { route: 'administracion/presupuestos-gastos/comparativo', modulo: '' },
        { route: 'administracion/presupuestos-gastos/:id/duplicar', modulo: '' },
        { route: 'administracion/presupuestos-gastos/:id/edit', modulo: '' },
        { route: 'administracion/presupuestos-gastos/:id', modulo: '' },

        { route: 'reportes', modulo: '' },
        { route: 'reportes/ventas', modulo: '' },
        { route: 'reportes/ventas/presupuestosinternos', modulo: '' },
        { route: 'reportes/ventas/presupuestos-internos-aperturas-cierres', modulo: '' },
        { route: 'reportes/ventas/presupuestos-internos-premios', modulo: '' },
        { route: 'reportes/ventas/ventas', modulo: '' },
        { route: 'reportes/ventas/ventas-comparativo', modulo: '' },
        { route: 'reportes/ventas/ventas-resumen-clientes', modulo: '' },
        // 'reportes/ventas/vendedores-comisiones',
        { route: 'reportes/compras', modulo: '' },
        { route: 'reportes/compras/compras-gastos', modulo: '' },
        { route: 'reportes/compras/percepciones', modulo: '' },
        { route: 'reportes/compras/compras-fecha', modulo: '' },
        { route: 'reportes/compras/resumen-gastos', modulo: '' },
        { route: 'reportes/compras/resumen-gastos/:id', modulo: '' },
        { route: 'reportes/clientes', modulo: '' },
        { route: 'reportes/clientes/deuda', modulo: '' },
        { route: 'reportes/clientes/cobros', modulo: '' },
        { route: 'reportes/clientes/plazos', modulo: '' },
        { route: 'reportes/clientes/retenciones', modulo: '' },
        { route: 'reportes/proveedores', modulo: '' },
        { route: 'reportes/proveedores/deuda', modulo: '' },
        { route: 'reportes/proveedores/ordenes-pendientes', modulo: '' },
        { route: 'reportes/proveedores/pagos', modulo: '' },
        { route: 'reportes/proveedores/plazos', modulo: '' },
        { route: 'reportes/administracion', modulo: '' },
        { route: 'reportes/administracion/flow', modulo: '' },
        { route: 'reportes/bancos', modulo: '' },
        { route: 'reportes/bancos/ingresos-gastos', modulo: '' }
    ]
}
